var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "67", height: "68", viewBox: "0 0 67 68", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "18.425", y: "49.074", width: "31.825", height: "1.675", rx: ".838", fill: "#606060" }),
    React.createElement("rect", { x: "11.725", y: "59.125", width: "11.725", height: "1.675", rx: ".838", fill: "#606060" }),
    React.createElement("rect", { x: "43.55", y: "59.125", width: "11.725", height: "1.675", rx: ".838", fill: "#606060" }),
    React.createElement("path", { d: "M18.425 59.625H18.925V59.125 9.7125C18.925 8.97382 18.3262 8.375 17.5875 8.375 16.8488 8.375 16.25 8.97382 16.25 9.7125V59.125 59.625H16.75 18.425zM50.25 59.625H50.75V59.125 9.7125C50.75 8.97382 50.1511 8.375 49.4125 8.375 48.6738 8.375 48.075 8.97382 48.075 9.7125V59.125 59.625H48.575 50.25z", fill: "#fff", stroke: "#606060" }),
    React.createElement("rect", { x: "6.7", y: "15.574", width: "53.6", height: "26.8", rx: "2", fill: "#fff", stroke: "#606060" }),
    React.createElement(
      "mask",
      { id: "id-109a", style: {
          maskType: "luminance"
        }, maskUnits: "userSpaceOnUse", x: "10", y: "18", width: "47", height: "22" },
      React.createElement("rect", { x: "10.05", y: "18.926", width: "46.9", height: "20.1", rx: "2", fill: "#fff" })
    ),
    React.createElement(
      "g",
      { mask: "url(#id-109a)", stroke: "#03AEB4", strokeWidth: "1.5", strokeLinecap: "square" },
      React.createElement("path", { d: "M-15.4937 44.0516L18.8438 8.87656M-5.4436 44.0516L28.8939 8.87656M4.60645 44.0516L38.9439 8.87656M14.6562 44.0516L48.9937 8.87656M24.7063 44.0516L59.0438 8.87656M34.7563 44.0516L69.0939 8.87656M44.8064 44.0516L79.1439 8.87656M54.8564 44.0516L89.1939 8.87656" })
    )
  );
});